import * as ClmtlkModel from './conversationContacts';

export function newMessage(){
    return <ClmtlkModel.Message>{};
};

export function newMessages() {
    return <ClmtlkModel.Messages>{
        message: [newMessage()]
    };
};

export function newThreadMessage() {
    return<ClmtlkModel.ThreadMessage>{
        messages: newMessages()
    };
};

export function newThreadMessages() {
    return<ClmtlkModel.ThreadMessages>{
        threadMessage: [newThreadMessage()]
    };
};

export function newThread() {
    return<ClmtlkModel.Thread>{
        threadMessages : newThreadMessages()
    };
};

export function newThreads() {
    return<ClmtlkModel.Threads>{
        thread: [newThread()]
    };
};

export function newConversationThread() {
    return<ClmtlkModel.ConversationThread>{
        threads: newThreads()
    };
};

export function newConversationThreads() {
    return <ClmtlkModel.ConversationThreads>{
        conversationThread: [newConversationThread()]
    };
};

export function newConversation(){
    return <ClmtlkModel.Conversation>{
        conversationThreads: newConversationThreads()
    };
};



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/shared/model/new-model-instance.ts